<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" type="ball-climbing-dot"><p class="text-white">Loading...</p></ngx-spinner>
